import { CButton, CDataTable } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// import history from "../../../config/history";
import { getMyNotifications } from "../../../api";
import LoadingComponent from "../../../Components/LoadingComponent";
import { changeSelectedChat } from "../../../actions/chatActions";
import "./notification.css";

const fields = [
  { key: "notification", label: "Notification" },
  { key: "type", label: "Type " },
  { key: "patientName", label: "Patient Name" },
  { key: "actions", label: "Actions" },
];

const Notification = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      const data = await getMyNotifications();
      setNotifications(data.data?.data);
      // console.log(data.data?.data);
      setLoading(false);
    })();
  }, []);

  console.log(notifications);

  return (
    <>
      {loading && <LoadingComponent />}
      {loading || (
        <div className="bg-white table__responsive ">
          <div className="custom-table">
            <CDataTable
              responsive
              addTableClasses={"bg-blue margin-table"}
              loading={loading}
              items={notifications}
              fields={fields}
              footer
              itemsPerPageSelect
              itemsPerPage={8}
              hover
              sorter
              pagination={{ align: "end", style: { "margin-right": "20px" } }}
              scopedSlots={{
                patientName: (item) => {
                  return (
                    <>
                      {
                        <td>{`${
                          item.data?.firstName ||
                          item?.data?.patientId?.firstName
                        } ${
                          item.data?.lastName || item?.data?.patientId?.lastName
                        }`}</td>
                      }
                    </>
                  );
                },
                notification: (item) => {
                  return (
                    <>
                      <td className="md:max-w-[350px] truncate ">
                        {item?.notification}
                      </td>
                    </>
                  );
                },
                actions: (item) => (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    {item.type === "Consultation" && (
                      <Link
                        to={`/dashboard/ViewConsutations/${item?.data?._id}`}
                      >
                        <CButton
                          className={"mt-2"}
                          style={{ padding: "5px 20px" }}
                          color="primary"
                          variant="outline"
                          shape="pill"
                          size="sm"
                        >
                          View
                        </CButton>
                      </Link>
                    )}
                    <CButton
                      className={"mt-2 ml-2"}
                      style={{ padding: "5px 20px" }}
                      color="primary"
                      variant="outline"
                      shape="pill"
                      size="sm"
                      onClick={() => {
                        dispatch(
                          changeSelectedChat(
                            item?.data?.chatRoomId || item?.data
                          )
                        );
                        history.push("/dashboard/messages");
                      }}
                    >
                      Chat
                    </CButton>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Notification;
